<template>
    <div class="app">
        <div class="end-wrap">
            <h2>冷暖风水系统设备选型</h2>
            <ul>
                <li
                    v-for="(fitem, findex) in data.arrPre"
                    :key="fitem.id"
                    v-show="fitem.product.length"
                >
                    <h3>
                        <div>{{ fitem.room | sFloor }}</div>
                    </h3>
                    <ol>
                        <li
                            v-for="(pit, pindex) in fitem.product"
                            :key="pit.system_id"
                            v-show="pit.arrGoods.length"
                        >
                            <h4>
                                <p>{{ pit.system_name }}</p>
                                <div class="btns">
                                    <div class="rate" v-if="pit.system_id == 1">
                                        <span>同开率</span>
                                        <!-- nRate   废弃全屋同开率 使用单层同开率-->
                                        <div
                                            @click="openPikerRate(pit, findex)"
                                        >
                                            {{ fitem.nPower }}%
                                        </div>
                                    </div>
                                    <p v-if="pit.system_id == 2">
                                        热水需求负荷：{{
                                            pit.water_energy
                                                ? Number(
                                                      pit.water_energy
                                                  ).toFixed(2)
                                                : ""
                                        }}kw
                                    </p>
                                    <p v-if="pit.system_id == 3">
                                        新风量需求：{{
                                            (
                                                pit.wind_energy *
                                                pit.wind_exchange
                                            ).toFixed(2)
                                        }}m³/hp
                                    </p>
                                    <div
                                        class="del"
                                        @click="
                                            delProduct(fitem.product, pindex)
                                        "
                                    ></div>
                                </div>
                            </h4>
                            <div class="detail">
                                <div v-if="pit.system_id == 1">
                                    <div class="input-line">
                                        <div class="item">
                                            <span>冷暖面积</span>
                                            <div class="s">
                                                <!-- energyColdArea(
                                                            fitem,
                                                            pit
                                                        ) -->
                                                <input
                                                    type="number"
                                                    :value="
                                                        hotOrcatArea.toFixed(2)
                                                    "
                                                    readonly
                                                />m²
                                            </div>
                                        </div>
                                        <div class="item">
                                            <span>设计温度</span>
                                            <div class="s write">
                                                <p @click="openPikerWd(pit)">
                                                    {{ pit.temperature }}
                                                </p>
                                                ℃
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-line">
                                        <div class="item">
                                            <span>需求负荷</span>
                                            <p>冷</p>
                                            <!-- (
                                                            (pit.power / 1000) *
                                                            (nRate
                                                                ? nRate / 100
                                                                : 1)
                                                        ).toFixed(2) -->
                                            <div class="m">
                                                <input
                                                    type="number"
                                                    :value="
                                                        (
                                                            (data.objInfo.energy_cold /
                                                                1000) *
                                                            (fitem.nPower
                                                                ? fitem.nPower /
                                                                  100
                                                                : 1)
                                                        ).toFixed(2)
                                                    "
                                                    readonly
                                                />KW
                                            </div>
                                        </div>
                                        <div class="item">
                                            <p>暖</p>
                                            <!-- (
                                                            (pit.power / 1000) *
                                                            (nRate
                                                                ? nRate / 100
                                                                : 1)
                                                        ).toFixed(2) -->
                                            <div class="m">
                                                <input
                                                    type="number"
                                                    :value="
                                                        (
                                                            (data.objInfo.energy_hot /
                                                                1000) *
                                                            (fitem.nPower
                                                                ? fitem.nPower /
                                                                  100
                                                                : 1)
                                                        ).toFixed(2)
                                                    "
                                                    readonly
                                                />KW
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="pit.system_id == 2">
                                    <div class="input-line">
                                        <div class="item mb">
                                            <span class="max"
                                                >冬季冷水温度</span
                                            >
                                            <div class="max">
                                                <input
                                                    v-model="pit.water_cold"
                                                    type="number"
                                                    readonly
                                                />
                                                <p>℃</p>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <span class="max"
                                                >热水设计流量</span
                                            >
                                            <div class="max write">
                                                <input
                                                    v-model="pit.water_rate"
                                                    @blur="
                                                        getHotProduct(
                                                            pit.water_rate
                                                        )
                                                    "
                                                    type="number"
                                                />
                                                <p>L/min</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="pit.system_id == 4">
                                    <div class="input-line">
                                        <div class="item mb">
                                            <span class="max"
                                                >最大净水用量</span
                                            >
                                            <div class="max">
                                                <input
                                                    v-model="pit.water_clean"
                                                    type="number"
                                                    readonly
                                                />
                                                <p>t/h</p>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <span class="max"
                                                >最大软水用量</span
                                            >
                                            <div class="max">
                                                <input
                                                    v-model="pit.water_soft"
                                                    type="number"
                                                    readonly
                                                />
                                                <p>t/h</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="pit.system_id == 3">
                                    <div class="input-line">
                                        <div class="item mb">
                                            <span class="max">换气次数</span>
                                            <div
                                                class="max write"
                                                @click="
                                                    openPikerWindNum(
                                                        pit,
                                                        findex,
                                                        pindex
                                                    )
                                                "
                                            >
                                                <input
                                                    v-model="pit.wind_exchange"
                                                    type="number"
                                                    readonly
                                                />
                                                <p>次/h</p>
                                            </div>
                                        </div>
                                        <div class="item">
                                            <span class="max">换气面积</span>
                                            <div class="max">
                                                <input
                                                    v-model="pit.wind_area"
                                                    type="number"
                                                    readonly
                                                />
                                                <p>m³</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="goods-list">
                                    <h5>
                                        <span>系统设备配置</span>
                                        <!-- <div>修改</div> -->
                                    </h5>
                                    <div
                                        class="item"
                                        v-for="(git, gindex) in pit.arrGoods"
                                        :key="git.product_id"
                                    >
                                        <p>
                                            <span
                                                >{{
                                                    git.new_goods_type_name ||
                                                    git.cate_name
                                                }}<span
                                                    class="blue"
                                                    v-if="git.num > 1"
                                                >
                                                    x{{
                                                        Number(git.num).toFixed(
                                                            0
                                                        )
                                                    }}</span
                                                ></span
                                            >
                                            <span
                                                class="btn"
                                                v-if="
                                                    git.new_goods_type_id != 214
                                                "
                                            >
                                                <span
                                                    @click="
                                                        editWind(
                                                            pit,
                                                            git,
                                                            findex,
                                                            pindex,
                                                            gindex,
                                                            fitem.room
                                                        )
                                                    "
                                                    >修改</span
                                                >
                                                <span
                                                    class="del"
                                                    @click="
                                                        delGoods(pit, gindex)
                                                    "
                                                    >删除</span
                                                >
                                            </span>
                                        </p>
                                        <p>
                                            <span>{{ git.goods_name }}</span>
                                        </p>
                                        <div class="content">
                                            <div class="img-box">
                                                <img
                                                    :src="
                                                        git.mobile_img ||
                                                        git.mobile_thumb
                                                    "
                                                    alt="图片"
                                                />
                                            </div>
                                            <div class="parameter">
                                                <p
                                                    v-for="(
                                                        ait, aindex
                                                    ) in git.attr_two"
                                                    :key="aindex"
                                                >
                                                    <span
                                                        >{{ ait.attr_name }}:
                                                    </span>
                                                    <span>{{
                                                        ait.attr_value
                                                    }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- 每层都有的替换 -->
                        <div class="btn-class" @click="addGood(findex)">
                            增加推荐品类
                        </div>
                    </ol>
                </li>
            </ul>
        </div>
        <!-- <div class="btn-class" @click="addMoreGood()">增加推荐品类</div> -->
        <div class="btn-offer" @click="submit">系统配置清单</div>
        <!-- 确认删除弹窗 -->
        <div class="mask" @touchmove.prevent v-if="data.bConfirmPopupShow">
            <div class="confirm-popup">
                <div
                    class="popup-close"
                    @click.stop="data.bConfirmPopupShow = false"
                ></div>
                <div class="confirm-content">
                    <p>{{ data.sDelTips }}</p>
                </div>
                <div class="confirm-btn">
                    <button @click.stop="data.bConfirmPopupShow = false">
                        取消
                    </button>
                    <button @click.stop="popupConfirm()">确定</button>
                </div>
            </div>
        </div>
        <!-- 选择温度 -->
        <awesome-picker
            ref="pickerwd"
            :anchor="data.arrAnchor"
            :data="data.arrNum"
            :colorConfirm="data.oPicker.colorConfirm"
            @confirm="confirmPickerwd"
        ></awesome-picker>
        <!-- 选择同开LV -->
        <awesome-picker
            ref="pickerrate"
            :anchor="data.arrAnchorRate"
            :data="data.arrRate"
            :colorConfirm="data.oPicker.colorConfirm"
            @confirm="confirmPickerRate"
        ></awesome-picker>
        <!-- 选择换风次数 -->
        <awesome-picker
            ref="pickwindnum"
            :anchor="data.arrAnchorWind"
            :data="data.arrWindNum"
            :colorConfirm="data.oPicker.colorConfirm"
            @confirm="confirmPickerWindNum"
        ></awesome-picker>
        <!-- 增加品类 -->
        <add-modal
            :title="data.sTypeTitle"
            :oGoodsInfo="data.oGoodsInfo"
            :nFindex="data.findex"
            @selectChange="addChange"
            :bEditModalShow.sync="data.bSearchModalShow"
        />
        <!-- 选择产品 -->
        <multiple-modal
            :title="data.sTypeTitle"
            :bEditModalShow.sync="data.bSearchModalShow2"
            @confirm="selectChange"
            :oGoodsInfo="data.oGoodsInfo"
        />
        <!-- 新版增加推荐品类，选择楼层弹窗 -->
        <addRooms
            :nRooms.sync="data.nRooms"
            :objInfo.sync="data.objInfo"
            @closeFloorConfirm="closeFloorConfirm"
        ></addRooms>
    </div>
</template>

<script>
import oForm from "@/js/form.js";
import addModal from "@/components/addModal/index";
import multipleModal from "@/components/multipleModal/index";
import addRooms from "../selection/components/addRooms/index";
import { getRoom } from "@/js/ant/basicinfov2.js";
import { objData } from "./data/objdata.js";
import { objWind, model, sort, option } from "@/js/ant/selection.js";
export default {
    components: {
        multipleModal,
        addModal,
        addRooms,
    },
    data() {
        return {
            data:objData(),
        };
    },
    filters: {
        sFloor(val) {
            return getRoom(val);
        },
    },
    created() {
        /* 初始化温度数据 15 - 30 */
        for (var i = 15; i < 31; i++) {
            this.data.arrNum.push({ value: i });
        }
        $init(() => {
            // 获取报告详情
            this.getReportInfo();
        });
    },
    methods: {
        //选择弹窗回调事件
        closeFloorConfirm(e) {
            this.data.findex = e;
            if (e == 1) {
                this.data.arrSelectList = [
                    { value: "变频户式空气热泵机组", id: 200 },
                    { value: "风机盘管机组", id: 201 },
                    { value: "壁挂炉", id: 2 },
                    { value: "中央新风系统", id: 206 },
                    { value: "前置过滤器", id: 207 },
                    { value: "中央净水机", id: 209 },
                    { value: "美容软水器", id: 210 },
                    { value: "净水机", id: 211 },
                    { value: "零逃逸油烟机", id: 212 },
                    { value: "大火力燃气灶", id: 213 },
                ];
            } else {
                this.data.arrSelectList = [
                    { value: "风机盘管机组", id: 201 },
                    { value: "壁挂炉", id: 2 },
                    { value: "中央新风系统", id: 206 },
                    { value: "前置过滤器", id: 207 },
                    { value: "中央净水机", id: 209 },
                    { value: "美容软水器", id: 210 },
                    { value: "净水机", id: 211 },
                    { value: "零逃逸油烟机", id: 212 },
                    { value: "大火力燃气灶", id: 213 },
                ];
            }
            this.data.nRooms = false;
            this.data.bSearchModalShow = true;
        },
        //呼出选择楼层弹窗
        addMoreGood() {
            this.data.nRooms = true;
        },
        energyColdArea(floorItem, productItem) {
            const arrfloor = this.data.arrPre.filter(
                (item) => item.product.length !== 0
            );
            if (arrfloor.length <= 1 && floorItem.room === 1) {
                return productItem.energy_cold_area;
            } else {
                let energyColdArea = this.data.arrPre.filter(
                    (item) => item.room === 1
                )[0].energy_cold_area;
                this.data.arrPre.forEach((item) => {
                    if (item.room !== 1) {
                        energyColdArea =
                            Number(energyColdArea) +
                            Number(item.energy_cold_area);
                    }
                });
                return floorItem.room === 1
                    ? energyColdArea.toFixed(2)
                    : productItem.energy_cold_area;
            }
        },
        // 确认删除
        popupConfirm() {
            if (this.data.bDelCate) {
                /* 删除分类 */
                this.data.arrPGoods.splice(this.data.nPIndex, 1);
                // 删除完成初始化
                this.data.bDelCate = false;
                this.data.nPIndex = 0;
                this.data.arrPGoods = [];
            } else if (this.data.bDelGood) {
                /* 删除商品 */
                this.data.oPit.arrGoods.splice(this.data.nGindex, 1);
            }
            // 关闭删除提示弹窗
            this.data.bConfirmPopupShow = false;
            this.$forceUpdate();
        },
        // 新增商品
        addGood(findex) {
            this.data.findex = findex;
            /* 增加品类，标题默认改为增加品类，goods_type_id=0*/
            this.data.sTypeTitle = "增加品类";
            this.data.oGoodsInfo = {
                goods_type_id: 0,
            };
            this.data.bSearchModalShow = true;
        },
        // 删除分类
        delProduct(arr, index) {
            this.data.nPIndex = index;
            this.data.arrPGoods = arr;
            this.data.bConfirmPopupShow = true;
            this.data.bDelCate = true;
            this.data.sDelTips = "删除当前分类吗？";
        },
        // 删除商品
        delGoods(pit, gindex) {
            this.data.oPit = pit;
            this.data.nGindex = gindex;
            this.data.bDelGood = true;
            this.data.bConfirmPopupShow = true;
            this.data.sDelTips = "删除当前商品吗？";
        },
        // 修改
        editWind(pitem, item, findex, pindex, gindex, rooms) {
            this.data.pindex = pindex;
            this.data.findex = findex;
            this.data.gindex = gindex;
            /* 修改商品，修改标题为当前分类名 */
            this.data.sTypeTitle = pitem.system_name;
            // 获取所有楼层id
            let arrFloor = [];
            this.data.arrPre.forEach((it) => {
                arrFloor.push({
                    room: it.room,
                });
            });
            // 现在所有商品都为多选
            this.data.bEditMore = true;
            let arr = [item];
            arr.map((it) => {
                it.cate_name = it.new_goods_type_name;
                it.mobile_thumb = it.mobile_img;
                it.nNum = it.num;
            });
            this.data.oGoodsInfo = objWind(
                pitem,
                item,
                this.data.nRate,
                rooms,
                arrFloor,
                arr
            );
            this.data.bSearchModalShow2 = true;
            // 修改状态 部委添加新品类
            this.data.isAdd = false;
        },
        // 换风次数
        openPikerWindNum(it, findex, pindex) {
            this.data.oPickWindNum = it;
            this.data.nFindex = findex;
            this.data.nPIndex = pindex;
            this.$refs.pickwindnum.show();
        },
        // 确认选择换风次数
        confirmPickerWindNum(res) {
            let nNum = res[0].value;
            this.data.oPickWindNum.wind_exchange = nNum;
            this.data.nWindExchange = nNum;
            this.data.arrPre[this.data.nFindex].product[this.data.nPIndex].wind_exchange =
                nNum;
            this.data.arrPower[this.data.nFindex].wind_exchange = nNum;
            /* 修改状态为更新换风次数 ，换风次数修改需要重新获取商品*/
            this.data.bChangeWind = true;
            this.reportPre(); //重新获取商品
        },
        // 修改设计流量
        getHotProduct(value) {
            if (isNaN(Number(value)) || Number(value) === 0) {
                this.$toast("请输入正确的数字");
                return false;
            }
            this.data.nWaterRate = Number(value);
            this.data.bHotWaterFlow = true;
            this.reportPre(); //重新获取商品
        },
        // 温度选择
        openPikerWd(it) {
            this.data.oProduct = it;
            this.$refs.pickerwd.show();
        },
        //确认选择温度
        confirmPickerwd(res) {
            let nNum = res[0].value;
            this.data.oProduct.temperature = nNum;
        },
        // 同开率
        openPikerRate(it, findex) {
            this.data.oProduct = it;
            //选择哪一层楼的同开率   索引
            this.data.nFindex = findex;
            this.$refs.pickerrate.show();
        },
        //确认选择同开率
        confirmPickerRate(res) {
            let nNum = res[0].value;
            this.data.oProduct.rate = nNum;
            this.data.arrPre.forEach((it) => {
                it.power = nNum;
                it.nPower = nNum;
            });
            this.data.arrPower.forEach((it) => {
                it.power = nNum;
            });
            this.data.nRate = nNum;
            /* 修改状态为更新同开率 ，同开率修改需要重新获取商品*/
            this.data.bChangeRate = true;
            this.reportPre(); //重新获取商品
            this.$forceUpdate();
        },
        // 添加品类回调
        addChange(arrAddProduct) {
            //  console.log(arrAddProduct);
            let arrProduct = this.data.arrPre[this.data.findex].product;
            let oPreUpgrade = this.data.arrPre[this.data.findex];
            arrAddProduct.forEach((item) => {
                if (arrProduct.length !== 0) {
                    let oItem = arrProduct.find((it) => {
                        return it.system_id == item.system_id;
                    });
                    // 给该系统分类arrGood商品列表添加该商品
                    if (oItem) {
                        // 按照选择商品的数量添加多个商品
                        oItem.arrGoods.push(item);
                    } else {
                        // 初始化系统分类
                        let oObj = {
                            system_id: item.system_id,
                            system_name: item.system_name,
                            arrGoods: [item],
                        };
                        arrProduct.push(oObj);
                    }
                } else {
                    // 初始化系统分类
                    let oObj = {
                        system_id: item.system_id,
                        system_name: item.system_name,
                        arrGoods: [item],
                    };
                    arrProduct.push(oObj);
                }
                // 初始化选项参数
                arrProduct.forEach((pit) => {
                    option(pit,oPreUpgrade);
                });
            });
        },
        // 选择商品弹窗回调
        selectChange(item) {
            //  console.log("选择商品", item);
            /* 判断是否为添加品类，后续逻辑修改添加品类不走这里改走addChange */
            if (!this.data.isAdd) {
                /* 判断是否为添加多个，目前都是为添加多个商品 */
                if (this.data.bEditMore) {
                    if (item.data.length) {
                        this.data.arrPre[this.data.findex].product[
                            this.data.pindex
                        ].arrGoods.splice(this.data.gindex, 1);
                        item.data.forEach((it) => {
                            // 找到楼层
                            let oFloor = this.data.arrPre.find((fit) => {
                                return fit.room === it.floor;
                            });
                            // 系统分类
                            let oSystem = oFloor.product.find((pit) => {
                                return pit.system_id == item.system_id;
                            });

                            /* 如果有系统分类，则清除该分类下分类id等于当前id的商品，因为每次选择商品都是重新选择整楼的商品*/
                            if (oSystem) {
                                let arrgood = oSystem.arrGoods.filter((it) => {
                                    return (
                                        it.new_goods_type_id !=
                                        item.goods_type_id
                                    );
                                });
                                oSystem.arrGoods = arrgood;
                            }
                        });
                        item.data.forEach((it) => {
                            // 找到楼层
                            let oFloor = this.data.arrPre.find((fit) => {
                                return fit.room === it.floor;
                            });
                            // 系统分类
                            let oSystem = oFloor.product.find((pit) => {
                                return pit.system_id == item.system_id;
                            });
                            // 按照选择商品的数量添加多个商品
                            it.num = it.nNum;
                            let arrGoods = [];
                            arrGoods.push(it);

                            /* 如果没有该系统分类，就初始化该系统分类，有的话直接在该系统分类下添加选择商品 */
                            if (!oSystem) {
                                sort(item, oFloor, arrGoods);
                            } else {
                                arrGoods.forEach((it) => {
                                    oSystem.arrGoods.push(it);
                                });
                            }
                            this.$forceUpdate();
                        });
                    }
                } else {
                    // 单选直接替换修改的商品
                    this.data.arrPre[this.data.findex].product[this.data.pindex].arrGoods[
                        this.data.gindex
                    ] = item;
                }
            }
        },
        // 提交
        submit() {
            let arr = [];
            this.data.arrPre.forEach((it) => {
                let obj = {
                    report_sub_id: it.id,
                };
                let oHot = it.product.find((pit) => {
                    return pit.system_id == 1;
                });
                let oHotWater = it.product.find((pit) => {
                    return pit.system_id == 2;
                });
                let oWind = it.product.find((pit) => {
                    return pit.system_id == 3;
                });
                let oWater = it.product.find((pit) => {
                    return pit.system_id == 4;
                });
                if (oHot) {
                    obj.energy_percent = it.nPower; //rate
                    obj.temperature_design = oHot.temperature;
                } else {
                    obj.energy_percent = "";
                    obj.temperature_design = "";
                }

                if (oHotWater) {
                    obj.water_cold = oHotWater.water_cold;
                    obj.water_rate = oHotWater.water_rate;
                } else {
                    obj.water_cold = "";
                    obj.water_rate = "";
                }

                if (oWind) {
                    obj.wind_exchange = oWind.wind_exchange;
                    obj.wind_area = oWind.wind_area;
                } else {
                    obj.wind_exchange = "";
                    obj.wind_area = "";
                }

                if (oWater) {
                    obj.water_clean = oWater.water_clean;
                    obj.water_soft = oWater.water_soft;
                } else {
                    obj.water_clean = "";
                    obj.water_soft = "";
                }

                let arrProduct = [];
                it.product.forEach((pit) => {
                    pit.arrGoods.forEach((git) => {
                        //  console.log(git);
                        arrProduct.push({
                            product_id: git.product_id || git.id,
                            num: git.num,
                        });
                    });
                });
                obj.product = arrProduct;
                arr.push(obj);
            });
            var arrAll = [...arr];
            //  console.log(arrAll);
            let oData = {
                product: JSON.stringify(arrAll),
            };
            this.$store.commit("loadSwitch", true);
            oForm.reportproduct(oData).then((res) => {
                this.$store.commit("loadSwitch", false);
                this.$router.replace("/ant/offter");
            });
        },
        // 获取报告详情
        getReportInfo() {
            let nReportId = this.$store.state.nAntReportId;
            if (!nReportId) {
                this.$toast("报告id错误！");
                return false;
            }
            let oData = {
                report_id: nReportId,
                show_sub: 1,
                show_room: 1,
                show_product: 1,
            };
            this.$store.commit("loadSwitch", true);
            oForm.getReportInfo(oData).then((res) => {
                let oInfo = res.data.data.result;
                this.arrFloorArea = oInfo.sub;
                this.data.objInfo = oInfo;
                this.nSchemeId = oInfo.scheme_id;
                this.nPower = oInfo.energy_cold;
                let arrPower = []; //同开率
                let zongProduct = 0;
                oInfo.product.forEach((item) => {
                    if (
                        item.new_goods_type_id != 215 ||
                        item.new_goods_type_id != 216
                    ) {
                        zongProduct += item.num;
                    }
                });
                let arrFterwat = 0;
                let hotOrcatArea = 0;
                oInfo.sub.forEach((it) => {
                    it.rooms.forEach((sit) => {
                        sit.product.forEach((item) => {
                            if (
                                (item.new_goods_type_id != 215 ||
                                    item.new_goods_type_id != 216) &&
                                sit.common_use == 0
                            ) {
                                arrFterwat += item.num;
                            }
                            if (item.new_goods_type_id == 201) {
                            }
                        });
                        let arr = sit.product.filter((it) => {
                            return it.new_goods_type_id == 201;
                        });
                        if (arr.length) {
                            hotOrcatArea += Number(sit.area);
                        }
                    });
                    //计算每层楼的同开率
                    arrPower.push({
                        room: it.room,
                        wind_exchange: it.wind_exchange,
                    });
                });
                this.hotOrcatArea = hotOrcatArea;
                let nRate = ((zongProduct - arrFterwat) / zongProduct) * 100;
                arrPower.forEach((it) => {
                    it.power = nRate;
                });
                this.data.nRate = nRate;
                this.data.arrPower = arrPower; //同开率
                // 获取选型商品
                this.reportPre();
            });
        },
        // 获取选型商品
        reportPre() {
            let nReportId = this.$store.state.nAntReportId;
            if (!nReportId) {
                this.$toast("报告id错误！");
                return false;
            }
            if (this.data.bChangeRate || this.data.bChangeWind) {
                this.$store.commit("loadSwitch", true);
            }
            oForm
                .reportPre({
                    report_id: nReportId,
                    power: JSON.stringify(this.data.arrPower),
                    sort_type: 0, //0每层 1全屋
                    water_rate: this.data.nWaterRate,
                })
                .then((res) => {
                    this.$store.commit("loadSwitch", false);
                    let objModel = res.data.data.result;
                    objModel = model(
                        this.data.bChangeRate,
                        this.data.bChangeWind,
                        objModel,
                        this.data.arrPre,
                        this.data.nRate,
                        this.data.arrPower,
                        this.data.bHotWaterFlow,
                        this.data.nWaterRate
                    );
                    this.data.bHotWaterFlow = false;
                    this.data.arrPre = objModel;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
